module.exports = __webpack_public_path__ + "static/media/teleconsultation.a24e01f8.png";